import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';
import { useTr } from '../contexts/LanguageContext';

const LANG_BAR_H = 34;

const PageLayout = ({ title, children }) => {
  const t = useTr();
  return (
    <div style={{ background: 'var(--sb-bg-1)', minHeight: '100vh' }}>
      <header className="fixed left-0 right-0 z-50 backdrop-blur-xl"
        style={{ top: LANG_BAR_H, background: 'rgba(0,0,0,0.92)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm transition-colors"
            style={{ color: 'rgba(255,255,255,0.6)' }}
            onMouseEnter={e => e.currentTarget.style.color = '#30d5c8'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}>
            <ArrowLeft size={15} />
            <span className="hidden sm:inline font-mono text-xs tracking-wider uppercase">SwarmBase</span>
          </Link>
          <div className="flex items-center gap-3">
            <img src="/logo.svg" alt="SwarmBase" className="w-7 h-7 object-contain" />
            <span className="font-outfit font-black text-sm" style={{ color: '#ffffff' }}>
              Swarm<span style={{ color: '#30d5c8' }}>Base</span>
              <span className="text-white/40 font-normal ml-2">/ {title}</span>
            </span>
          </div>
          <a href="https://core.swarmbase.io" target="_blank" rel="noopener noreferrer"
            className="text-xs font-mono px-4 py-1.5 rounded border transition-all"
            style={{ border: '1px solid #30d5c8', color: '#30d5c8' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#30d5c8'; e.currentTarget.style.color = '#000'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#30d5c8'; }}>
            {t('Open dApp', 'dApp 열기')}
          </a>
        </div>
      </header>
      <main style={{ paddingTop: `calc(4rem + ${LANG_BAR_H}px)` }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
